import styled, { css } from 'styled-components'

import CloseIcon from '../../../../../assets/icons/filter-icons/close-icon.svg'
import type { StyledSvgComponent } from '../../../../../types/svg'

export const Container = styled.div(
    ({ theme }) => css`
        height: 3.5rem;
        width: 100%;
        box-sizing: border-box;
        cursor: pointer;
        display: ${theme.style.display.flex};
        border-bottom: ${theme.typography.border.width.xxxThin} solid #0000001a;
    `,
)

export const CloseIconStyled = styled(CloseIcon as StyledSvgComponent)`
    height: ${({ theme }) => theme.layout.xSmall};
    width: ${({ theme }) => theme.layout.xSmall};
    margin: ${({ theme }) => theme.spacing.medium};
`

export const HeaderLabel = styled.strong(
    ({ theme }) => css`
        flex-grow: 1;
        padding: 0.875rem 0 0.875rem 1.5rem;
        letter-spacing: -0.021875rem;
        font: ${theme.typography.font.lato.weight.black} ${theme.typography.font.size.large} / 1.75rem
            ${theme.typography.font.family.latoVerdana};
    `,
)

export const ClearAllLabel = styled.span(
    ({ theme }) => css`
        padding: ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium} 0;
        text-align: right;
        color: ${theme.colors.tfwBlue12};
        font: ${theme.typography.font.lato.weight.regular} ${theme.typography.font.size.small} /
            ${theme.typography.font.size.xLarge} ${theme.typography.font.family.latoVerdana};
    `,
)
